import React, { useEffect,useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import Image from 'next/image';
import PropTypes from 'prop-types';

import ZpButton from 'components/zpButton';
import { useCtxHistory } from 'hooks';
import { getCookie, importStatic,openInCurrentTab, setCookie } from 'utils';

import { getUserProfile } from '../../services/userService';
import { openSignUpModal } from '../../store/modals/actions';

import classes from './continueSurvey.module.css';

const initialCookie = {
  item: '_zippia-continue-survey',
  expiredays: 365,
  path: '/',
};

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  times: PropTypes.number,
  link: PropTypes.string,
  isEnabled: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  openSurveyBtnText: PropTypes.string,
  surveyName: PropTypes.string,
  newVersion: PropTypes.bool,
  linkTitle: PropTypes.string,
  noNegBottomMargin: PropTypes.bool,
};

const ContinueSurvey = ({
  title,
  description,
  link,
  times,
  isEnabled,
  isLoggedIn,
  openSurvey,
  openSurveyBtnText,
  surveyName,
  openSignUpModal,
  newVersion,
  linkTitle,
  noNegBottomMargin,
}) => {
  const [isHide, setIsHide] = useState(true);
  const [timesLeft, setTimesLeft] = useState(times);
  const [isEnabledSurvey, setisEnabledSurvey] = useState(isEnabled);
  const userGroup = "groupA";
  const history = useCtxHistory();

  useEffect(() => {
    const checkUser = async () => {
      const cookieData = getCookie('_zippia-continue-survey');
      // const continueSurveyGoogleTest = getCookie('_zippia-continueSurveyGoogleTest');

      /* if (continueSurveyGoogleTest) {
                setUserGroup(continueSurveyGoogleTest);
            }*/

      if (cookieData) {
        const { show, left, closeTime } = JSON.parse(decodeURIComponent(cookieData));

        const timeDifference = new Date() - new Date(closeTime);
        const hoursDifference = Math.floor(timeDifference / 1000 / 60 / 60);

        if (show && left !== 0 && (hoursDifference >= 48 || closeTime === '')) {
          const {
            profile: { other_preferences },
          } = await getUserProfile();

          if (!isEmpty(other_preferences)) {
            const { titles = [], userLocation = [] } = other_preferences;

            const isNotFilled = isEmpty(titles) || isEmpty(userLocation);

            if (isNotFilled) {
              setIsHide(false);
              setTimesLeft(left);
            }
          }
        }
      } else {
        const {
          profile: { other_preferences },
        } = await getUserProfile();

        if (!isEmpty(other_preferences)) {
          const { titles = [], userLocation = [] } = other_preferences;

          const isNotFilled = isEmpty(titles) || isEmpty(userLocation);

          if (isNotFilled) {
            setIsHide(false);
          }

          setCookie({
            ...initialCookie,
            value: JSON.stringify({
              show: isNotFilled,
              left: times,
              closeTime: '',
            }),
          });
        }
      }
    };

    if (isEnabled && isLoggedIn) {
      checkUser();
    }
  }, []);

  const redirect = () => {
    let url = link;

    if (newVersion) {
      switch (userGroup) {
        case 'groupB':
        case 'groupC':
          url = '/profile/jobs/?src=callout-prompt';
          break;
      }
    }

    openInCurrentTab(url);
  };

  const signUpPopup = () => {
    const src = `${link}`;
    const query = {
      survey_step: 'step1',
      survey: surveyName,
      src,
    };
    if (isLoggedIn && surveyName === '201') {
      query.skipQuestion = [7];
    }
    openSignUpModal({
      ...query,
      popupType: 'career-callout-sign-up',
    });
    history.pushQuery(query);
  };

  const close = () => {
    setCookie({
      ...initialCookie,
      value: JSON.stringify({
        show: true,
        left: timesLeft - 1,
        closeTime: new Date(),
      }),
    });
    setIsHide(true);
    setisEnabledSurvey(false);
  };

  const getLink = () => {
    let title = linkTitle;

    switch (userGroup) {
      case 'groupB':
        title = 'Add your goals and preferences';
        break;
      case 'groupC':
        title = 'Add your preferences';
        break;
    }

    return (
      <button className="zp-btn zp-btn-trans p-0" onClick={openSurvey ? signUpPopup : redirect}>
        {openSurvey ? openSurveyBtnText : title}
      </button>
    );
  };

  const userGroupTitle = () => {
    switch (userGroup) {
      case 'groupB':
        return '<link> to get the most out of Zippia.';
      case 'groupC':
        return 'What are you looking for? Tell us to get personalized job listings. <link>';
      case 'groupA':
      default:
        return 'Get the most out of Zippia, add your goals and preferences. <link>';
    }
  };

  const getTitle = () => {
    const text = title || userGroupTitle();

    return <>{text.split('<link>').map((item) => (item === '' ? getLink() : item))}</>;
  };

  if ((isHide && !openSurvey) || (openSurvey && !isEnabledSurvey)) {
    return null;
  }

  if (newVersion) {
    return (
      <div
        className={classNames(
          classes['continue-survey'],
          classes['new-version'],
          'continue-survey d-flex justify-content-between align-items-center',
          { [classes['continue-survey-margin-bottom']]: noNegBottomMargin }
        )}
      >
        <div className="d-flex align-items-center">
          <div className="continue-survery-icon-container">
            <Image
              src={importStatic('/ui-router/images/continue-survey-icon.png')}
              width="28"
              height="28"
            />
          </div>
          <p className="semi-bold-font mb-0 ml-3">{getTitle()}</p>
        </div>
        <div
          className="continue-survey-close d-flex flex-column justify-content-center align-items-center"
          onClick={close}
        />
      </div>
    );
  }

  return (
    <div className={classNames(classes['continue-survey'], 'd-flex continue-survey')}>
      <div className="row">
        <div className="col-12 d-flex justify-content-end d-lg-none">
          <div
            className="continue-survey-close d-flex flex-column justify-content-center align-items-center"
            onClick={close}
          />
        </div>
        <div className="col-12 col-lg-8 info w-635">
          <h3>{title}</h3>
          <p>{description}</p>
          {openSurvey ? (
            <ZpButton theme="primary" size="big" onClick={signUpPopup}>
              {openSurveyBtnText}
            </ZpButton>
          ) : (
            <ZpButton theme="primary" size="big" onClick={redirect}>
              Add My Preferences
            </ZpButton>
          )}
        </div>
        <div className="d-none d-lg-flex flex-column col-lg-4 justify-content-between align-items-end">
          <div
            className="continue-survey-close d-flex flex-column justify-content-center align-items-center"
            onClick={close}
          />
          <Image
            width="297"
            height="167"
            src={importStatic('/ui-router/images/continue-survey.svg')}
          />
        </div>
      </div>
    </div>
  );
};

ContinueSurvey.defaultProps = {
  openSurveyBtnText: 'Calculate',
  link: '/profile/jobs/?src=callout-prompt',
  linkTitle: 'Add My Preferences',
  times: 3,
  isEnabled: true,
  isLoggedIn: false,
  openSurvey: false,
  surveyName: '201',
  newVersion: false,
  noNegBottomMargin: false,
};
ContinueSurvey.propTypes = propTypes;

const mapDispatchToProps = {
  openSignUpModal,
};
const mapStateToProps = ({ user }) => ({ isLoggedIn: user.isLoggedIn });

export const ContinueSurveyComponent = ContinueSurvey;

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(ContinueSurvey));
